import { filter } from 'rxjs/operators';

import { Component, OnInit } from '@angular/core';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { AbstractInputComponent } from '@shared/form-elements/input/abstract-input/abstract-input.component';
import { TranslateSafePipe } from '@shared/translate-safe/translate-safe.pipe';
import { InputComponent } from '../input/input.component';

/**
 * Input with controlled value so it's in the XX/XX/XXXX format.
 * If the user types XX it'll automatically enter the / so it becomes XX/
 * If the user is removing a character, for example going from XX/ to XX it does not include the / back, only removes non numeric and non / characters
 */
@UntilDestroy()
@Component({
    selector: 'app-input-birth-date',
    templateUrl: './input-birth-date.component.html',
    imports: [InputComponent, TranslateSafePipe]
})
export class InputBirthDateComponent extends AbstractInputComponent implements OnInit {
    private previousValue: string = '';

    ngOnInit(): void {
        this.control.valueChanges
            .pipe(
                filter(value => value),
                untilDestroyed(this)
            )
            .subscribe((value: string) => {
                const removingCharacters = value.length <= this.previousValue.length;
                if (removingCharacters) {
                    this.control.setValue(value.replace(/[^0-9/+]/g, '').substring(0, 10), { emitEvent: false });
                } else {
                    let formattedValue = value.replace(/[^0-9+]/g, '').substring(0, 8);
                    if (formattedValue.length >= (removingCharacters ? 4 : 4)) {
                        formattedValue = `${formattedValue.substring(0, 4)}/${formattedValue.substring(4)}`;
                    }
                    if (formattedValue.length >= (removingCharacters ? 2 : 2)) {
                        formattedValue = `${formattedValue.substring(0, 2)}/${formattedValue.substring(2)}`;
                    }
                    this.control.setValue(formattedValue, { emitEvent: false });
                }
                this.previousValue = value;
            });
    }
}
